/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
// import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

// const promoBgUrl = getAssetUrl('static/img/header-promo-bg-img.jpg');

export default {
    baseStyle: {
        container: {
            minWidth: 'xs',
            maxWidth: [
                'container.base',
                'container.sm',
                'container.md',
                'container.lg',
                'container.xl',
                'container.2xl'
            ],
            width: '100%',
            margin: '0 auto',
            paddingLeft: {base: '16px', sm: '32px', xl: '64px'},
            paddingRight: {base: '16px', sm: '32px', xl: '64px'},
            paddingTop: {base: '0px'},
            paddingBottom: {base: '0px'}
        },
        content: {
            maxWidth: 'container.2xl',
            marginLeft: 'auto',
            marginRight: 'auto',
            paddingLeft: {base: 4, md: 6, lg: 8},
            paddingRight: {base: 4, md: 6, lg: 8},
            paddingTop: {base: 1, md: 2, lg: 4},
            paddingBottom: {base: 3, md: 2, lg: 4}
        },
        searchContainer: {
            order: {base: 2, sm: 'inherit'},
            marginRight: {base: 0}
        },
        bodyContainer: {},
        logo: {
            width: {base: '155px', sm: '255px'},
            marginRight: {base: '16px', lg: '30px'}
        },
        hamburgerIcon: {
            top: 'inherit',
            position: 'absolute',
            width: '100%',
            height: '100vh',
            background: '#000000a3'
        },
        accountIcon: {
            height: 11,
            minWidth: 'auto',
            cursor: 'pointer',
            alignSelf: {base: 'self-start', lg: 'auto'},
            _focus: {
                boxShadow: 'outline'
            },
            _focusVisible: {
                outline: 0
            }
        },
        arrowDown: {
            minWidth: 'auto',
            marginRight: 0,
            marginBottom: {base: 1, md: 2, lg: 0},
            alignSelf: {base: 'self-start', lg: 'auto'},
            cursor: 'pointer',
            _focus: {
                boxShadow: 'outline'
            },
            _focusVisible: {
                outline: 0
            },
            display: {base: 'none', lg: 'block'},
            position: 'absolute',
            opacity: '0',
            height: '40px',
            width: '40px'
        },
        wishlistIcon: {
            // More breathing room between the account and wishlist icons
            marginLeft: 2
        },
        signout: {
            width: '100%',
            borderRadius: '4px',
            height: 11,
            padding: 4,
            py: 3,
            marginTop: 1,
            _hover: {
                background: 'gray.50'
            }
        },
        signoutText: {
            fontSize: 'sm',
            fontWeight: 'normal'
        },
        signoutIcon: {
            marginRight: 2
        },
        promoBgImage: {
            //background: `url(${promoBgUrl}) no-repeat`,
            overflow: 'hidden',
            clear: 'both',
            backgroundPosition: '50%',
            backgroundSize: 'cover',
            padding: {base: '0 12px', sm: '0 32px'},
            boxShadow: 'inset -1px -1px 1px 1px hsla(0, 0%, 100%, .05)'
        },
        headerPromoBlock: {
            float: 'left',
            width: {base: 'full', sm: '60%'},
            padding: {base: '6px', sm: '12px 0'},
            textAlign: {base: 'center', sm: 'left'},
            fontSize: {base: '12px', sm: '16px'},
            color: 'textColorInvert'
        },
        svodLinkMainBlock: {
            float: 'right',
            width: '40%',
            textAlign: 'right',
            paddingTop: {base: '6px', sm: '12px'},
            paddingBottom: {base: '6px', sm: '12px'},
            display: {base: 'none', sm: 'block'}
        },
        headerIconsBlock: {
            marginLeft: {base: '16px', md: '20px'},
            padding: '0',
            float: 'left',
            display: 'flex',
            width: {base: 'calc(100% - 232px)', sm: '84px', md: '170px'},
            justifyContent: 'right'
        },
        headerIcons: {
            lineHeight: '21px',
            border: 'none',
            fontSize: '10px',
            width: '10px',
            height: '20px',
            left: '21px',
            fontWeight: 'normal'
        },
        search: {
            padding: '0 12px'
        },
        loginBlock: {
            direction: 'column',
            position: 'absolute',
            top: '100%',
            margin: 0,
            background: 'headerBgColor',
            color: 'textColorInvert',
            zIndex: 999,
            textTransform: 'capitalize',
            borderRadius: '0 0 8px 8px',
            textAlign: 'left'
        },
        loginText: {
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: '800',
            lineHeight: '16px',
            padding: '16px 24px',
            _hover: {
                color: 'orangeBaseColor'
            }
        }
    },
    parts: [
        'container',
        'content',
        'searchContainer',
        'siteHeader',
        'bodyContainer',
        'logo',
        'icons',
        'signout',
        'bgImage'
    ]
}
